import { CashFlowExpenseSubReportItem } from "bus/cash/types/cashFlowExpenseSubReport";

export const initValue: CashFlowExpenseSubReportItem = {
  comment: '',
  date: '',
  sum: 0,
  cashFlowAccount: null,
  confirmedSum: 0,
  employeeId: null
};